import { render, staticRenderFns } from "./CardServe.vue?vue&type=template&id=7315d294&scoped=true&"
import script from "./CardServe.vue?vue&type=script&lang=js&"
export * from "./CardServe.vue?vue&type=script&lang=js&"
import style0 from "./CardServe.vue?vue&type=style&index=0&id=7315d294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7315d294",
  null
  
)

export default component.exports